import { ImportDetailPanel } from 'src/applications/Oversight/panels/ImportDetailPanel'

export const ImportDetailScene = () => <ImportDetailPanel />
